<template>
  <div class="landing-container">
    <span class="log">{{ loginType }}</span>
    <div v-if="isshowalert">
      <AlertErrormodal
        v-if="isshowalert && errors.length > 0"
        :isshowalert="isshowalert"
        :modalcontent="errors"
        :title="title"
        @ChangeAlertError="ChangeAlertError($event)"
      />
    </div>

    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
  </div>
</template>

<script>
import AlertError from '@/components/Modal/AlertError'
import AlertErrormodal from '@/components/Modal/AlertErrormodal'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import Account from '@/helper/AccountHelper.js'
import CheckCookie from '@/mixin/CheckCookie'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import _ from 'lodash'

export default {
  name: 'LandingEmail',
  components: {
    AlertErrormodal,
    AlertError,
  },
  mixins: [CommonMixin, ResponsiveMixin, CheckCookie],
  data() {
    return {
      loginTypeList: [],
      isshowalert: false,
      errors: [],
      dataError: {},
      showError: false,
      loginType: '',
      log: null,
    }
  },
  computed: {
    checkInput() {
      if (this.mobileNumber) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    this.handleFooter(false)
    this.checklocalStorage().then(() => {
      Account.removeCacheCustom(
        'setRegister_' + Account.getCacheCustom('app_id'),
      )
      this.init()
    })
  },

  methods: {
    init() {
      this.handleCheckAppId(this.$route)
      if (
        Account.getCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ) != null
      ) {
        if (
          Account.getCacheCustom('BzbsUser_' + Account.getCacheCustom('app_id'))
            .appId == null
        ) {
          window.location.href = '/error/404'
        } else {
          this.AppId = Account.getCacheCustom(
            'BzbsUser_' + Account.getCacheCustom('app_id'),
          ).appId
        }
      } else {
        window.location.href = '/error/404'
      }

      this.handleLanguage(false)
      this.handleLoading(true)
      this.getCustomerStore()
    },
    goto(name) {
      this.$router.push({ name: name })
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLanding(res)

            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            if (_.isEmpty(error.response)) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            } else {
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            }

            resolve(error)
          })
      })
    },
    async handleLanding(res) {
      this.loginType = res.data.StoreDetail.LoginType
      this.handleLogintype(res.data.StoreDetail.LoginType)
      if (
        this.loginTypeList.includes('Email') ||
        this.loginTypeList.includes('Facebook')
      ) {
        if (this.$route.query.returnURL) {
          window.location.href =
            '/login?returnURL=' + this.$route.query.returnURL
        } else {
          window.location.href = '/login'
        }
      } else if (this.loginTypeList.includes('Device')) {
        if (this.$route.query.returnURL) {
          window.location.href =
            '/loginOTP?returnURL=' + this.$route.query.returnURL
        } else {
          window.location.href = '/loginOTP'
        }
      } else {
        if (this.$route.query.returnURL) {
          window.location.href =
            '/login?returnURL=' + this.$route.query.returnURL
        } else {
          window.location.href = '/login'
        }
      }
    },
    handleLogintype(loginType) {
      this.loginTypeList = loginType.split(',')
    },

    //Error
    ChangeAlertError(value) {
      this.isshowalert = value
    },
    ChangeError(event) {
      this.showError = event
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_mixin.scss';
.landing-container {
  height: 100vh;
  background-color: #ffffff;
  padding: 16px;
  padding-bottom: 40px;
  overflow: auto;
  position: relative;

  .log {
    position: absolute;
    bottom: 0;
    right: 0;
    color: $color-light-text;
    font-size: 14px;
  }
}
</style>
